import { createReducer } from 'redux-act';
import {requestScreenContentReportData, responseScreenContentReportData} from './action';


const defaultState = {
	requestProcess: false,
};

const reducer = createReducer({

	[requestScreenContentReportData]: (state) => {
    return {
      requestProcess: true,
	  	data: [],
    };
  },

  [responseScreenContentReportData]: (state, params) => {
		return {
			requestProcess: false,
			data: params,
		};
	},


}, defaultState);



export default reducer
